import { get, post } from '@/utils/request';

const url = 'we-chat-orders';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getRefundList(data) {
  return get({
    url: `${url}/refunds`,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function applyRefund({ course_reservation_id, we_chat_order_id, store_id }) {
  return post({
    url: `${url}/${we_chat_order_id}`,
    data: {
      course_reservation_id,
      store_id,
    },
  });
}
